import {useSelector} from 'react-redux';
import {eventInEditMode} from '~/CreateFabricInvitation/reducers/details/selectors';
import {selectRsvpOptional} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {Rsvps as RsvpsComponent} from '~/CreateFabricInvitation/routes/EventDetails/components/Rsvps';
import './Rsvps.sass';

export const Rsvps = () => {
  const rsvpOptional = useSelector(selectRsvpOptional);
  const inEditMode = useSelector(eventInEditMode);

  if (!rsvpOptional || inEditMode) {
    return null;
  }

  return (
    <div className="one-step-flow__rsvp">
      <RsvpsComponent description="Evite will collect 'Yes' or 'No' RSVPs from your guests." />
    </div>
  );
};
